import {CheckInFormValues, validateRequiredTrailerNumber, validateRequiredDriverFirstName, validateRequiredDriverLastName, validateRequiredAssetSize, validateOptionalScacCode} from '../../util/check-in-field-validation';

/**
 * Validates the default fields for Trailer Empty check-in.
 * Covers: TRUCK_TRAILER_EMPTY, TRAILER_EMPTY.
 * Required: trailerNumber, driverFirstName, driverLastName, assetSize.
 */
export const validateTrailerEmptyForm = (values: CheckInFormValues): string | undefined =>
  validateRequiredTrailerNumber(values.trailerNumber) ??
  validateRequiredDriverFirstName(values.driverFirstName) ??
  validateRequiredDriverLastName(values.driverLastName) ??
  validateRequiredAssetSize(values.assetSize) ??
  validateOptionalScacCode(values.scacCode);
